import { Divider } from "@mui/material";
import React from "react";
import FileIcon from "../Icons/FileIcon";
import BottomStatusUpdate from "./BottomStatusUpdate";
// import { Link } from "react-router-dom";
// import { MdOutlineArrowBack } from "react-icons/md";

function EmploymentInformation() {
  return (
    <div className="">
      <section>
        <div className="bg-white  pt-[24px] pb-[24px] px-[24px]">
          <div className="  flex flex-col md:flex-row justify-between  rounded-t-lg mt-6  ">
            <p className="text-[24px] ">Employment Information</p>
            <div className="text-[#1E87FF]  flex gap-2 items-center">
              <p className="text-[14px]">Edit</p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0002 15.1663H6.00016C2.38016 15.1663 0.833496 13.6197 0.833496 9.99967V5.99967C0.833496 2.37967 2.38016 0.833008 6.00016 0.833008H7.3335C7.60683 0.833008 7.8335 1.05967 7.8335 1.33301C7.8335 1.60634 7.60683 1.83301 7.3335 1.83301H6.00016C2.92683 1.83301 1.8335 2.92634 1.8335 5.99967V9.99967C1.8335 13.073 2.92683 14.1663 6.00016 14.1663H10.0002C13.0735 14.1663 14.1668 13.073 14.1668 9.99967V8.66634C14.1668 8.39301 14.3935 8.16634 14.6668 8.16634C14.9402 8.16634 15.1668 8.39301 15.1668 8.66634V9.99967C15.1668 13.6197 13.6202 15.1663 10.0002 15.1663Z"
                  fill="#1E87FF"
                />
                <path
                  d="M5.66688 11.7934C5.26022 11.7934 4.88688 11.6467 4.61355 11.38C4.28688 11.0534 4.14688 10.58 4.22022 10.08L4.50688 8.07337C4.56022 7.68671 4.81355 7.18671 5.08688 6.91337L10.3402 1.66004C11.6669 0.333372 13.0135 0.333372 14.3402 1.66004C15.0669 2.38671 15.3935 3.12671 15.3269 3.86671C15.2669 4.46671 14.9469 5.05337 14.3402 5.65337L9.08688 10.9067C8.81355 11.18 8.31355 11.4334 7.92688 11.4867L5.92022 11.7734C5.83355 11.7934 5.74688 11.7934 5.66688 11.7934ZM11.0469 2.36671L5.79355 7.62004C5.66688 7.74671 5.52022 8.04004 5.49355 8.21337L5.20688 10.22C5.18022 10.4134 5.22022 10.5734 5.32022 10.6734C5.42022 10.7734 5.58022 10.8134 5.77355 10.7867L7.78022 10.5C7.95355 10.4734 8.25355 10.3267 8.37355 10.2L13.6269 4.94671C14.0602 4.51337 14.2869 4.12671 14.3202 3.76671C14.3602 3.33337 14.1335 2.87337 13.6269 2.36004C12.5602 1.29337 11.8269 1.59337 11.0469 2.36671Z"
                  fill="#1E87FF"
                />
                <path
                  d="M13.2335 6.55319C13.1869 6.55319 13.1402 6.54652 13.1002 6.53319C11.3469 6.03986 9.95353 4.64652 9.4602 2.89319C9.38687 2.62652 9.5402 2.35319 9.80687 2.27319C10.0735 2.19986 10.3469 2.35319 10.4202 2.61986C10.8202 4.03986 11.9469 5.16652 13.3669 5.56652C13.6335 5.63986 13.7869 5.91985 13.7135 6.18652C13.6535 6.41319 13.4535 6.55319 13.2335 6.55319Z"
                  fill="#1E87FF"
                />
              </svg>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
          Basic
        </div>
        <div className="flex gap-8 bg-white pt-7 pb-8 px-[24px]">
          <div className="text-[#98A2B3] flex flex-col gap-4">
            <div className="text-end text-[14px] font-[400]">
              Application date
            </div>
            <div className="text-end text-[14px] font-[400]">
              Position applying for
            </div>
            <div className="text-end text-[14px] font-[400]">
              Employment type
            </div>
            <div className="text-end text-[14px] font-[400]">
              Name (Last, first, middle)
            </div>
            <div className="text-end text-[14px] font-[400]">
              Social Security Number (SSN)
            </div>
            <div className="text-end text-[14px] font-[400]">City</div>
            <div className="text-end text-[14px] font-[400]">State</div>
            <div className="text-end text-[14px] font-[400]">Zip Code</div>
            <div className="text-end text-[14px] font-[400]">Phone</div>
            <div className="text-end text-[14px] font-[400]">Email address</div>
            <div className="text-end text-[14px] font-[400]">Home address</div>
          </div>

          <div className="text-[#292727]  flex flex-col gap-4">
            <div className=" text-[14px] font-[400]">19-02-23</div>
            <div className=" text-[14px] font-[400]">Psychologist</div>
            <div className=" text-[14px] font-[400]">Full Time</div>
            <div className=" text-[14px] font-[400]">Cameron Williamson</div>
            <div className=" text-[14px] font-[400]">011587845</div>
            <div className=" text-[14px] font-[400]">San Francisco</div>
            <div className=" text-[14px] font-[400]">California</div>
            <div className=" text-[14px] font-[400]">78577</div>
            <div className=" text-[14px] font-[400]">(225) 555-0118</div>
            <div className=" text-[14px] font-[400]">Email address</div>
            <div className=" text-[14px] font-[400]">
              3891 Ranchview Dr. Richardson, California 62639
            </div>
          </div>
        </div>
      </section>

      <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
        License
      </div>
      <section className="bg-white    py-5">
        <div className="flex gap-8 px-[24px]">
          <div className="text-[#98A2B3] flex flex-col gap-4">
            <div className="text-end text-[14px] font-[400]">License type</div>
            <div className="text-end text-[14px] font-[400]">
              License/Certification #
            </div>
            <div className="text-end text-[14px] font-[400]">State</div>
            <div className="text-end text-[14px] font-[400]">
              Expiration date
            </div>
          </div>

          <div className="text-[#292727] font-bold flex flex-col gap-4">
            <div className=" text-[14px] font-[400]">
              Consultative Telemedicine
            </div>
            <div className=" text-[14px] font-[400]">9631</div>
            <div className=" text-[14px] font-[400]">Oklahoma</div>
            <div className=" text-[14px] font-[400]">19-02-23</div>
          </div>
        </div>

        <div className="mt-8 mb-8">
          <Divider />
        </div>

        <section className="px-[24px]">
          <p className="mt-8 mb-8 text-[#98A2B3] text-[14px]">
            Have your license ever been suspended, revoked, or under
            investigation?
          </p>
          <p className="font-[400] text-[14px]">No</p>

          <p className="mt-8 mb-8 text-[#98A2B3] text-[14px]">
            If Yes, please explain:
          </p>

          <p className="font-[400] text-[#98A2B3]">-</p>
        </section>
      </section>

      <section>
        <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
          Certifications
        </div>

        <div className="flex gap-8 bg-white pt-7 pb-8 px-[24px]">
          <div className="text-[#292727] flex flex-col gap-4">
            <div className="text-[#98A2B3] text-[14px] font-[14px]">Name</div>
            <div className="text-[14px] font-[14px]">ACLS</div>
            <div className="text-[14px] font-[14px]">BCLS</div>
            <div className="text-[14px] font-[14px]">PALS</div>
          </div>

          <div className="text-[#292727] flex flex-col gap-4">
            <div className="text-[14px] font-[14px] text-[#98A2B3]">
              Expiration date
            </div>
            <div className="text-[14px] font-[14px]">19-02-23</div>
            <div className="text-[14px] font-[14px]">19-02-23</div>
            <div className="text-[14px] font-[14px]">19-02-23</div>
          </div>
        </div>
      </section>

      <section className="">
        <div className=" flex flex-col md:flex-row justify-between py-4 px-[24px]  bg-white">
          <p className="text-[24px]">Availability & Area of travel</p>
          <div className="text-[#1E87FF]  flex gap-2 items-center">
            <p className="text-[14px]">Edit</p>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0002 15.1663H6.00016C2.38016 15.1663 0.833496 13.6197 0.833496 9.99967V5.99967C0.833496 2.37967 2.38016 0.833008 6.00016 0.833008H7.3335C7.60683 0.833008 7.8335 1.05967 7.8335 1.33301C7.8335 1.60634 7.60683 1.83301 7.3335 1.83301H6.00016C2.92683 1.83301 1.8335 2.92634 1.8335 5.99967V9.99967C1.8335 13.073 2.92683 14.1663 6.00016 14.1663H10.0002C13.0735 14.1663 14.1668 13.073 14.1668 9.99967V8.66634C14.1668 8.39301 14.3935 8.16634 14.6668 8.16634C14.9402 8.16634 15.1668 8.39301 15.1668 8.66634V9.99967C15.1668 13.6197 13.6202 15.1663 10.0002 15.1663Z"
                fill="#1E87FF"
              />
              <path
                d="M5.66688 11.7934C5.26022 11.7934 4.88688 11.6467 4.61355 11.38C4.28688 11.0534 4.14688 10.58 4.22022 10.08L4.50688 8.07337C4.56022 7.68671 4.81355 7.18671 5.08688 6.91337L10.3402 1.66004C11.6669 0.333372 13.0135 0.333372 14.3402 1.66004C15.0669 2.38671 15.3935 3.12671 15.3269 3.86671C15.2669 4.46671 14.9469 5.05337 14.3402 5.65337L9.08688 10.9067C8.81355 11.18 8.31355 11.4334 7.92688 11.4867L5.92022 11.7734C5.83355 11.7934 5.74688 11.7934 5.66688 11.7934ZM11.0469 2.36671L5.79355 7.62004C5.66688 7.74671 5.52022 8.04004 5.49355 8.21337L5.20688 10.22C5.18022 10.4134 5.22022 10.5734 5.32022 10.6734C5.42022 10.7734 5.58022 10.8134 5.77355 10.7867L7.78022 10.5C7.95355 10.4734 8.25355 10.3267 8.37355 10.2L13.6269 4.94671C14.0602 4.51337 14.2869 4.12671 14.3202 3.76671C14.3602 3.33337 14.1335 2.87337 13.6269 2.36004C12.5602 1.29337 11.8269 1.59337 11.0469 2.36671Z"
                fill="#1E87FF"
              />
              <path
                d="M13.2335 6.55319C13.1869 6.55319 13.1402 6.54652 13.1002 6.53319C11.3469 6.03986 9.95353 4.64652 9.4602 2.89319C9.38687 2.62652 9.5402 2.35319 9.80687 2.27319C10.0735 2.19986 10.3469 2.35319 10.4202 2.61986C10.8202 4.03986 11.9469 5.16652 13.3669 5.56652C13.6335 5.63986 13.7869 5.91985 13.7135 6.18652C13.6535 6.41319 13.4535 6.55319 13.2335 6.55319Z"
                fill="#1E87FF"
              />
            </svg>
          </div>
        </div>

        <section className="">
          <div className="flex gap-8 bg-white pt-2 pb-8 px-[24px]">
            <div className="text-[#292727] flex flex-col gap-4">
              <div className="text-[14px] text-[#98A2B3] ">Day</div>
              <div className="text-[14px]">Sunday</div>
              <div className="text-[14px]">Tuesday</div>
              <div className="text-[14px]">Wednesday</div>
            </div>

            <div className="text-[#292727]  flex flex-col gap-4">
              <div className=" text-[#98A2B3] text-[14px] ">Time</div>
              <div className="  text-[14px]">9:00am - 4:00pm</div>
              <div className="  text-[14px]">9:00am - 4:00pm</div>
              <div className="  text-[14px]">9:00am - 4:00pm</div>
            </div>
          </div>
          <div className="text-[#292727] flex flex-col gap-4 bg-white pb-8 px-[24px]">
            <div className="text-[#98A2B3] text-[14px] font-[400]">
              Area of Travel
            </div>
            <div className="text-[14px] font-[400]">Los Angeles</div>
          </div>
        </section>
      </section>

      <section className="">
        <div className="flex flex-col md:flex-row justify-between px-[24px] gap-4 pb-5 bg-white">
          <p className="text-[24px] ">Work experience</p>
          <div className="text-[#1E87FF]  flex gap-2 items-center">
            <p className="text-[14px]">Edit</p>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0002 15.1663H6.00016C2.38016 15.1663 0.833496 13.6197 0.833496 9.99967V5.99967C0.833496 2.37967 2.38016 0.833008 6.00016 0.833008H7.3335C7.60683 0.833008 7.8335 1.05967 7.8335 1.33301C7.8335 1.60634 7.60683 1.83301 7.3335 1.83301H6.00016C2.92683 1.83301 1.8335 2.92634 1.8335 5.99967V9.99967C1.8335 13.073 2.92683 14.1663 6.00016 14.1663H10.0002C13.0735 14.1663 14.1668 13.073 14.1668 9.99967V8.66634C14.1668 8.39301 14.3935 8.16634 14.6668 8.16634C14.9402 8.16634 15.1668 8.39301 15.1668 8.66634V9.99967C15.1668 13.6197 13.6202 15.1663 10.0002 15.1663Z"
                fill="#1E87FF"
              />
              <path
                d="M5.66688 11.7934C5.26022 11.7934 4.88688 11.6467 4.61355 11.38C4.28688 11.0534 4.14688 10.58 4.22022 10.08L4.50688 8.07337C4.56022 7.68671 4.81355 7.18671 5.08688 6.91337L10.3402 1.66004C11.6669 0.333372 13.0135 0.333372 14.3402 1.66004C15.0669 2.38671 15.3935 3.12671 15.3269 3.86671C15.2669 4.46671 14.9469 5.05337 14.3402 5.65337L9.08688 10.9067C8.81355 11.18 8.31355 11.4334 7.92688 11.4867L5.92022 11.7734C5.83355 11.7934 5.74688 11.7934 5.66688 11.7934ZM11.0469 2.36671L5.79355 7.62004C5.66688 7.74671 5.52022 8.04004 5.49355 8.21337L5.20688 10.22C5.18022 10.4134 5.22022 10.5734 5.32022 10.6734C5.42022 10.7734 5.58022 10.8134 5.77355 10.7867L7.78022 10.5C7.95355 10.4734 8.25355 10.3267 8.37355 10.2L13.6269 4.94671C14.0602 4.51337 14.2869 4.12671 14.3202 3.76671C14.3602 3.33337 14.1335 2.87337 13.6269 2.36004C12.5602 1.29337 11.8269 1.59337 11.0469 2.36671Z"
                fill="#1E87FF"
              />
              <path
                d="M13.2335 6.55319C13.1869 6.55319 13.1402 6.54652 13.1002 6.53319C11.3469 6.03986 9.95353 4.64652 9.4602 2.89319C9.38687 2.62652 9.5402 2.35319 9.80687 2.27319C10.0735 2.19986 10.3469 2.35319 10.4202 2.61986C10.8202 4.03986 11.9469 5.16652 13.3669 5.56652C13.6335 5.63986 13.7869 5.91985 13.7135 6.18652C13.6535 6.41319 13.4535 6.55319 13.2335 6.55319Z"
                fill="#1E87FF"
              />
            </svg>
          </div>
        </div>

        <section>
          <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
            Facilities
          </div>

          <div className="flex gap-8 bg-white pt-7 pb-8 px-[24px]">
            <div className="text-[#292727] flex flex-col gap-4">
              <div className="text-[14px]">Hospital </div>
              <div className="text-[14px]">Nursing Home</div>
              <div className="text-[14px]">Assisted Living</div>
            </div>
          </div>
        </section>
      </section>

      <section className="">
        <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
          Experience & skill
        </div>

        <div className="flex gap-8 bg-white pt-7 pb-8 px-[24px]">
          <div className="text-[#292727] flex flex-col gap-4">
            <div className="text-[14px] text-[#98A2B3]">Skill</div>
            <div className="text-[14px]">Burn</div>
            <div className="text-[14px]">Detox/Drug Rehab</div>
            <div className="text-[14px]">Orthopedics</div>
            <div className="text-[14px]">Stepdown</div>
            <div className="text-[14px]">Oncology</div>
            <div className="text-[14px]">SICU </div>
          </div>

          <div className="text-[#292727]  flex flex-col gap-4">
            <div className="text-[#98A2B3] text-[14px]">
              Years of experience
            </div>
            <div className="text-[14px]">2</div>
            <div className="text-[14px]">1</div>
            <div className="text-[14px]">1</div>
            <div className="text-[14px]">1</div>
            <div className="text-[14px]">1</div>
            <div className="text-[14px]">1</div>
          </div>
        </div>
      </section>

      <section>
        <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
          Work experience
        </div>

        <div className="flex gap-8 bg-white pt-7 pb-8 px-[24px]">
          <div className="text-[#98A2B3] flex flex-col gap-4 text-[14px] text-end font-[400]">
            <div>Employer name</div>
            <div>Start date</div>
            <div>End date</div>
            <div>Address</div>
            <div>City, state, Zip</div>
            <div>Job Title</div>
            <div>May we contact this employer</div>
            <div>Name of supervisor</div>
            <div>Telephone number</div>
            <div>Reason for leaving</div>
            <div>Supervisory experience</div>
          </div>

          <div className="text-[#292727]  flex flex-col gap-4 text-[14px] font-[400]">
            <div>Jacob Jones</div>
            <div>11-7-16</div>
            <div>7-18-17</div>
            <div>4140 Parker Rd. Allentown, New Mexico 31134</div>
            <div>New Mexico</div>
            <div>Psychologist</div>
            <div>Yes</div>
            <div>Savannah Nguyen</div>
            <div>(270) 555-0117</div>
            <div>Furthering Education</div>
            <div>No</div>
          </div>
        </div>
      </section>

      <section className="">
        <div className="font-bold flex flex-col py-3 px-[24px] text-[#98A2B3] text-[12px] headerbg">
          Other
        </div>

        <div className="flex gap-4 flex-col bg-white pt-7 pb-8 px-[24px] text-[14px]">
          <p className="text-[#98A2B3] mt-3 text-[14px] lg:max-w-[70%] md:max-w-[80%] max-w-[100%]">
            Use this space to list any other work-related information you think
            would be helpful to us in considering you for employment, such as
            specialized training, other certifications, additional work
            experience, etc.
          </p>
          <p className="text-[#292727] text-[14px]">
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet, consequat duis enim velit
            mollit.
          </p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            Are you legally authorized to work in the USA?
          </p>
          <p className="text-[#292727] ">Yes</p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            Have you ever been convicted of a felony?
          </p>
          <p className="text-[#292727] ">No</p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            Can you pass a pre-employment drug test?
          </p>
          <p className="text-[#292727] ">Yes</p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            How were you referred to Care In Touch Home Health Agency?
          </p>
          <p className="text-[#292727] ">Friend</p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            I understand that I must report all accidents to my immediate
            supervisor and to Care In Touch Home Health Agency – NO MATTER HOW
            SLIGHT
          </p>
          <p className="text-[#292727] ">Yes</p>

          <p className="text-[#98A2B3] mt-4 lg:max-w-[80%] md:max-w-[85%] max-w-[100%]">
            I also understand that I must wear all required personal protection
            equipment (PPE). The penalty for not wearing PPE is disciplinary
            action, up to and including termination.
          </p>
          <p className="text-[#292727] ">Yes</p>
        </div>
      </section>

      <section className="py-8 px-[24px]  bg-white">
        <p className="text-[#292727] text-[24px]">Acknowledgement</p>
        <div className="flex gap-4 mt-5 mb-8">
          <FileIcon /> <p className="text-[12px]">Acknowledgement.pdf</p>
        </div>
      </section>

      <section className="py-8 px-[24px]  bg-white">
        <p className="text-[#292727] text-[24px]">Statement of employability</p>
        <div className="flex gap-4 mt-5 mb-8">
          <FileIcon />{" "}
          <p className="text-[12px]">Statement of employability.pdf</p>
        </div>
      </section>

      <section className="py-8 px-[24px]  bg-white">
        <p className="text-[#292727] text-[24px]">Reference release form</p>
        <div className="flex gap-4 mt-5 mb-8">
          <FileIcon /> <p className="text-[12px]">Reference release form.pdf</p>
        </div>
      </section>
      <section className="py-8 px-[24px]  bg-white">
        <p className="text-[#292727] text-[24px]">Interview</p>
        <div className="flex gap-4 mt-5 mb-8">
          <FileIcon />{" "}
          <p className="text-[12px]">Pre employment interview questions.pdf</p>
        </div>
      </section>

      <div>
        <BottomStatusUpdate />
      </div>
    </div>
  );
}

export default EmploymentInformation;
